/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CdInputs */

const en_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const es_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const fr_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const de_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const ja_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const zh_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const ar_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قرص مضغوط (CD)`)
};

const id_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const it_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const ru_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const pt_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

const ko_val_cd = /** @type {(inputs: Val_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CD`)
};

/**
* | output |
* | --- |
* | "CD" |
*
* @param {Val_CdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_cd = /** @type {((inputs?: Val_CdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_cd(inputs)
	if (locale === "es") return es_val_cd(inputs)
	if (locale === "fr") return fr_val_cd(inputs)
	if (locale === "de") return de_val_cd(inputs)
	if (locale === "ja") return ja_val_cd(inputs)
	if (locale === "zh") return zh_val_cd(inputs)
	if (locale === "ar") return ar_val_cd(inputs)
	if (locale === "id") return id_val_cd(inputs)
	if (locale === "it") return it_val_cd(inputs)
	if (locale === "ru") return ru_val_cd(inputs)
	if (locale === "pt") return pt_val_cd(inputs)
	return ko_val_cd(inputs)
});